import React from 'react'
import PropTypes from 'prop-types'
import Logo from 'widgets/branding/Logo'

/**
 * Sidebar mobile
 */
function SidebarTablet (props) {
  return (
    <div className='flex flex-shrink-0'>
      <div className='flex flex-col w-24 bg-white py-6'>
        <div className='flex items-center flex-shrink-0 px-8'>
          <Logo />
        </div>
        <div className='h-0 flex-1 flex flex-col overflow-y-auto overflow-x-hidden'>
          {props.children}
        </div>
      </div>
    </div>
  )
}

export default SidebarTablet
